export type AudienceChartDate = { date: Date; label: string };

const parseYearMonth = (input: string): Date => {
  const [year, month] = input.split('-').map(Number);

  return new Date(year, month - 1);
};

const formatMonthLabel = (date: Date): string => date.toLocaleString('en-US', { month: 'short' });

export const toAudienceChartDate = (input: string): AudienceChartDate => {
  const date = parseYearMonth(input);
  const label = formatMonthLabel(date);

  return { date, label };
};
